import { render, staticRenderFns } from "./consent.vue?vue&type=template&id=1a496939&scoped=true"
import script from "./consent.vue?vue&type=script&lang=js"
export * from "./consent.vue?vue&type=script&lang=js"
import style0 from "./consent.vue?vue&type=style&index=0&id=1a496939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a496939",
  null
  
)

export default component.exports